var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('MUIDialog',{ref:"dialog",class:_vm.classNames,style:(_vm.styles),attrs:{"displayType":_vm.displayType,"navItem":_vm.navItem}},[_c('progressive-img',{attrs:{"src":_vm.temporaryViewProps.url,"placeholder":_vm.temporaryViewProps.placeholder,"aspect-ratio":_vm.invertedAspectRatio},on:{"onLoadPlaceholder":_vm.onLoadPlaceholder}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-275ea379","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/ImageDialog.vue
// module id = null
// module chunks = 